__turbopack_context__.v({
  "deliveryWrap": "product-delivery-module-scss-module__Rg8dbG__deliveryWrap",
  "popoverContent": "product-delivery-module-scss-module__Rg8dbG__popoverContent",
  "productDelivery": "product-delivery-module-scss-module__Rg8dbG__productDelivery",
  "regionButton": "product-delivery-module-scss-module__Rg8dbG__regionButton",
});
